import { Offcanvas } from "react-bootstrap";
import Loader from "../Loader";
import { useState } from "react";
import TextEditor from "./editor";
import { LucideSendHorizontal } from "lucide-react";
import { FaRegClock } from "react-icons/fa";
import { ScheduleModal } from "../EmailComposer/modals";

const ComposeMail = ({ showComposeEmailModal, setShowComposeEmailModal }) => {
    const initialContent = `
    <p>Dear Wipro Team,</p><br/>
    <p>
      A very warm welcome from all of us at <strong>Digylax Private Limited</strong>! 
      We are excited to embark on this journey together and look forward to supporting your success. 
      At Digylax, we specialize in modern enterprise solutions designed to power efficiency, foster innovation, 
      and drive growth for leading organizations across industries.
    </p><br/>

    <p>
      We are thrilled to introduce <strong>Digylax CRM</strong>, our flagship customer relationship management solution. 
      Digylax CRM is built on a <strong>Data Vault–powered architecture</strong>, enabling AI-driven lead generation 
      by identifying high-potential prospects and automating intelligent customer engagement. 
      Our platform supports the full lifecycle—from prospect identification, automated AI communication, 
      to lead conversion—making your sales process seamless and highly productive.
    </p><br/>

    <p>
      With features such as a unified dashboard, advanced lead & account management, detailed deal tracking, 
      automated communication, AI-powered prospect generation, integrated meeting scheduling, 
      and comprehensive analytics, Digylax CRM empowers your teams to streamline customer interactions, 
      optimize sales pipelines, and drive sustained business growth.
    </p><br/>

    <p>
      We believe that Digylax CRM will deliver significant value to Wipro by centralizing your client management, 
      improving prospecting effectiveness through AI, and automating repetitive tasks so your teams can focus 
      on what truly matters—building stronger relationships and delivering outstanding results.
    </p><br/>

    <p>
      Thank you for choosing Digylax as your trusted technology partner. 
      Should you need any support or have any questions, please feel free to reach out. 
      We’re here to ensure a smooth and successful experience for your team.
    </p><br/>

    <p>
      Thanks,<br/>
      <strong>Dhavapriya Vadivel</strong><br/>
      Digylax Private Limited
    </p>
  `;

    let [showLoader, setShowLoader] = useState(true);
    let [content, setContent] = useState(initialContent);
    let [showScheduleModal, setShowScheduleModal] = useState(false);

    setTimeout(() => {
        setShowLoader(false);
    }, 1000);

    const handleSendEmail = () => {
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
            setShowComposeEmailModal(false);
        }, 1000);
    };

    const handleShowScheduleEmail = () => {
        setShowScheduleModal(true);
    }

    const handleScheduleEmail = () => {
        setShowScheduleModal(false);
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
            setShowComposeEmailModal(false);
        }, 1000);
    }




    const handleImageUpload = () => {
        console.log('image handler')
    }

    return (
        <>
            <Offcanvas placement='end'
                show={showComposeEmailModal}
                onHide={() => { setShowComposeEmailModal(false); }}
                className="emails timeline-offcanvas"
                backdrop={true}
                scroll={false}>
                <Offcanvas.Header closeButton className="pb-2 position-relative">
                    <Offcanvas.Title>Compose</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="vh-100" style={{ overflow: 'scroll' }}>
                    <Loader isVisible={showLoader} isModal={true} overall={false} />
                    <div>
                        <TextEditor content={content} setContent={setContent} toolbar={true} />
                    </div>
                    <div class="text-start ps-0 form-footer position-absolute bottom-0 w-100 bg-white border-top ps-4 py-3 d-flex position-fixed col-lg-12">
                        <button class="btn btn-outline-primary btn-blue me-3 p-2" type="button" onClick={() => handleShowScheduleEmail()}><FaRegClock className="me-1" />Schedule</button>
                        <button class="btn btn-primary btn-blue" type="button" onClick={() => handleSendEmail()}><LucideSendHorizontal className="me-1" />Send</button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            {showScheduleModal &&
                <ScheduleModal
                    showScheduleModal={showScheduleModal}
                    setShowScheduleModal={setShowScheduleModal}
                    handleSchedule={handleScheduleEmail}
                />
            }
        </>
    )
}
export default ComposeMail;